import {ContractError} from './world-contract.mjs';
import {findSafeSpawn} from './spawn-safety.mjs';
import {invitedPlayer} from './invite-spawn.mjs';

// The only non-doorway destination offered by this action is the trusted home.
// No caller-supplied position, destination, account or presence is accepted.
export function returnedValoriaPlayer(player,world) {
  if(world?.id!=='valoria'||world.ownerId!=='system')throw new ContractError('Valoria is unavailable. Please try again. ',503,'VALORIA_RETURN_UNAVAILABLE');
  const position=findSafeSpawn(world);
  if(!position)throw new ContractError('A safe Valoria arrival is unavailable.',503,'VALORIA_RETURN_UNAVAILABLE');
  return invitedPlayer(player,world,position);
}

// Shares the exact promise during repeat taps. A failed operation can be retried
// by the user, never automatically replayed after an uncertain network outcome.
export function createValoriaReturnAction({getPlayer,leaveActivity,request,apply,onBusy=()=>{}}) {
  let pending=null;
  return function returnToValoria(){
    if(pending)return pending;
    const identity=getPlayer()?.id;
    pending=(async()=>{
      onBusy(true);
      if(!await leaveActivity())return false;
      if(getPlayer()?.id!==identity)throw Error('Your session changed. Reload before returning.');
      const result=await request();
      if(getPlayer()?.id!==identity||result?.player?.id!==identity)throw Error('Your session changed. Reload before returning.');
      if(result?.world?.id!=='valoria'||result?.player?.worldId!=='valoria')throw Error('The return to Valoria was not confirmed.');
      apply(result);return true;
    })().finally(()=>{pending=null;onBusy(false);});
    return pending;
  };
}
